<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 8 10" fill="none">
  <path d="M1.066 5.429a1 1 0 0 1 0-1.6L5.9.201a1 1 0 0 1 1.6.8v7.256a1 1 0 0 1-1.6.8z" fill="currentColor"></path>
</svg>